import { addSlidesTabIndex } from '@parent-theme/assets/js/helpers/swiper/add-slides-tab-index';

const dynamicSliderInit = () => {
    const mainPattern = document.querySelectorAll('.gg-insights-boxes-carousel');

    mainPattern.forEach((module) => {
        const swipers = module.querySelector('.posts-result');
        const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');

        const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
        const swiperNext = module.querySelector('.gg-insights-boxes-carousel__next-btn > a');
        const swiperPrev = module.querySelector('.gg-insights-boxes-carousel__prev-btn > a');

        if (!swipers || !swiperWrapper) {
            return;
        }
        swipers.classList.add('swiper-container');
        swiperWrapper.classList.add('swiper-wrapper');
        swiperSlides.forEach((slide) => {
            slide.classList.add('swiper-slide');
        });

        const carousel = new window.Swiper(swipers, {
            loop: swiperSlides.length > 4,
            centeredSlides: false,
            watchOverflow: true,
            watchSlidesProgress: true,
            slidesPerGroup: 1,
            slidesPerView: 'auto',
            allowTouchMove: true,
            navigation: {
                prevEl: swiperPrev,
                nextEl: swiperNext,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                },
                1025: {
                    slidesPerView: 2.7,
                    spaceBetween: 48,
                },
                750: {
                    slidesPerView: 2.1,
                    spaceBetween: 32,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
                200: {
                    slidesPerView: 1.1,
                    spaceBetween: 24,
                },
            },
            on: {
                init: (swiper) => addSlidesTabIndex(swiper),
                slideChange: (swiper) => addSlidesTabIndex(swiper),
            },
        });
        carousel.init();
    });
};
dynamicSliderInit();
